import { Trans } from "@lingui/react/macro"
import React from "react"

import { useLocale } from "../../../../utils/hooks/use-locale"
import { DEFAULT_LOCALE } from "../../../../utils/locales/constants"
import {
  TREMENDOUS_DEVELOPER_DOCS,
  TREMENDOUS_HELP_URL,
  TREMENDOUS_STATUS_URL,
} from "../../../../utils/urls"
import {
  BriefCase,
  Check,
  Desktop,
  HelpWithPerson,
  Newspaper,
  OpenBook,
  Person,
  Tremendous,
} from "../../../icon/icon-static-map"
import DropdownHighlight from "../dropdown-highlight"
import DropdownMain from "../dropdown-main"
import NavList from "../nav-list"
import NavListItem from "../nav-list-item"

const ResourcesDropdown = () => {
  const locale = useLocale()

  return (
    <>
      <DropdownMain>
        <NavList title={<Trans>learn</Trans>}>
          <NavListItem
            href={TREMENDOUS_HELP_URL}
            icon={<HelpWithPerson color="gold" size="small" />}
            label={<Trans>Help center</Trans>}
            text={<Trans>Make the most of the Tremendous platform</Trans>}
            target="_blank"
          />
          <NavListItem
            href="/case-studies"
            icon={<Person color="gold" size="small" />}
            label={<Trans>Case studies</Trans>}
            text={<Trans>Real stories of time, money, and hassle saved</Trans>}
          />
          <NavListItem
            href="/blog"
            icon={<Desktop color="orange" size="small" />}
            label={<Trans>Blog</Trans>}
            text={<Trans>New insights every week</Trans>}
          />
        </NavList>
        <NavList title={<Trans>company</Trans>}>
          <NavListItem
            href="/about"
            icon={<Tremendous color="original" size="small" />}
            label={<Trans>About us</Trans>}
            text={<Trans>Helping businesses send payouts to people</Trans>}
          />
          <NavListItem
            href="/careers"
            icon={<BriefCase color="magenta" size="small" />}
            label={<Trans>Careers</Trans>}
            text={<Trans>It's great working here, join us</Trans>}
            badge={locale === DEFAULT_LOCALE ? "hiring!" : undefined}
          />
          <NavListItem
            href="/newsroom"
            icon={<Newspaper color="orange" size="small" />}
            label={<Trans>Newsroom</Trans>}
            text={<Trans>The latest on all things Tremendous</Trans>}
          />
        </NavList>
        <NavList title={<Trans>for developers</Trans>}>
          <NavListItem
            href={TREMENDOUS_DEVELOPER_DOCS}
            icon={<OpenBook color="orange" size="small" />}
            label={<Trans>Documentation</Trans>}
            text={<Trans>By devs, for devs</Trans>}
            target="_blank"
          />
          <NavListItem
            href={TREMENDOUS_STATUS_URL}
            icon={<Check color="magenta" size="small" />}
            label={<Trans>Status</Trans>}
            text={<Trans>Current and historic uptime</Trans>}
            target="_blank"
          />
        </NavList>
      </DropdownMain>
      <DropdownHighlight category="resources" />
    </>
  )
}

export default ResourcesDropdown
